import React from 'react';
import { useNavigate } from 'react-router-dom';
// import Header from '../components/Header';

export default function SMCDirectory() {
  const navigate = useNavigate();
  const [tutors, setTutors] = React.useState([]);
  const [searchId, setSearchId] = React.useState("");
  const [subject, setSubject] = React.useState("All Subjects");
  const [filtered, setFiltered] = React.useState([]);

  // Track page view with Google Analytics
  React.useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-CC8DD4BS2W', {
        page_path: '/directory/smc',
        page_title: 'SMC PTK Directory'
      });
    }
  }, []);

  React.useEffect(() => {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
    fetch(`${API_BASE_URL}/api/tutors`)
      .then(res => res.json())
      .then(data => {
        console.log('Fetched tutors:', data); // Debug log
        // Only show tutors whose school is SMC.
        const smcTutors = data.filter(tutor =>
          (tutor.school || '').trim().toLowerCase() === 'smc'
        );
        console.log('SMC tutors:', smcTutors); // Debug log
        setTutors(smcTutors);
        setFiltered(smcTutors);
      })
      .catch(err => {
        console.error('Error fetching tutors:', err);
      });
  }, []);

  function handleFilter() {
    setFiltered(
      tutors.filter(tutor => {
        const idMatch = searchId.trim() === "" || String(tutor.id).toLowerCase().includes(searchId.trim().toLowerCase());
        
        // Check both subject field and subjects array
        const hasSubject = tutor.subject || (Array.isArray(tutor.subjects) && tutor.subjects.length > 0);
        const subjectMatch = subject === "All Subjects" || 
          (tutor.subject && tutor.subject.toLowerCase() === subject.toLowerCase()) ||
          (Array.isArray(tutor.subjects) && tutor.subjects.some(s => s.toLowerCase() === subject.toLowerCase()));
        
        return idMatch && subjectMatch;
      })
    );
  }

  // Get all unique subjects for the dropdown
  const getAllSubjects = () => {
    const subjects = new Set();
    tutors.forEach(tutor => {
      if (tutor.subject) subjects.add(tutor.subject);
      if (Array.isArray(tutor.subjects)) {
        tutor.subjects.forEach(s => subjects.add(s));
      }
    });
    return Array.from(subjects).sort();
  };

  return (
    <div>
      {/* <Header /> */}
      <div style={{padding: '2.5rem', background: '#f7f9fb', minHeight: '100vh'}}>
        <h1 style={{fontSize: '2.3rem', marginBottom: 28, fontWeight: 800, letterSpacing: 1}}>SMC PTK Tutor Directory</h1>
        <p style={{marginBottom: 28, fontSize: "1.05rem", color: "#333"}}>
          This directory is reserved for Santa Monica College students. All listed tutors are PTK Honor Society members. To protect their privacy, we do not list individual names here. If you have any questions, please email us at smcptktutors@gmail.com.
        </p>
        <div style={{
          marginBottom: 32,
          display: 'flex',
          gap: 12,
          flexWrap: 'wrap',
          alignItems: 'center',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 12px #e0e0e0',
          padding: '1rem 1.5rem',
          maxWidth: 760,
          width: '100%'
        }}>
          <input
            placeholder="Search by Tutor ID"
            value={searchId}
            onChange={e => setSearchId(e.target.value)}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #bbb',
              borderRadius: 8,
              fontSize: 16,
              flex: '2 1 240px'
            }}
          />
          <select
            value={subject}
            onChange={e => setSubject(e.target.value)}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #bbb',
              borderRadius: 8,
              fontSize: 16,
              flex: '1 1 220px'
            }}
          >
            <option>All Subjects</option>
            {getAllSubjects().map(subj => (
              <option key={subj}>{subj}</option>
            ))}
          </select>
          <button
            onClick={handleFilter}
            style={{
              background: '#04d664',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '0.6rem 1.5rem',
              fontWeight: 600,
              fontSize: 16,
              flexShrink: 0,
              cursor: 'pointer',
              boxShadow: '0 1px 4px #cceedd'
            }}
          >Filter</button>
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 32,
          justifyContent: 'flex-start',
          marginTop: 8
        }}>
          {filtered.map(tutor => {
            // Combine subject and subjects for display
            const displaySubjects = [];
            if (tutor.subject) displaySubjects.push(tutor.subject);
            if (Array.isArray(tutor.subjects)) {
              tutor.subjects.forEach(s => {
                if (!displaySubjects.includes(s)) displaySubjects.push(s);
              });
            }
            
            return (
              <div key={tutor.id} style={{
                background: '#fff',
                border: 'none',
                boxShadow: '0 2px 16px #e0e0e0',
                padding: '1.5rem',
                width: 260,
                borderRadius: 18,
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                fontSize: 17
              }}>
                <div style={{fontWeight: 700, fontSize: 18, marginBottom: 2}}>ID: {tutor.id}</div>
                <div><b>Subjects:</b> {displaySubjects.length > 0 ? displaySubjects.join(', ') : '—'}</div>
                <div><b>Available Time:</b> {tutor.time || '—'}</div>
                <div><b>Gender:</b> {tutor.gender || '—'}</div>
                <div><b>School:</b> {tutor.school || '—'}</div>
                <div><b>Graduation Year:</b> {tutor.gradYear || '—'}</div>
                <div style={{marginTop: 16, display: 'flex', gap: 10}}>
                  <button onClick={() => navigate(`/register?tutor=${tutor.id}&school=smc`)} style={{
                    background: '#04d664',
                    color: 'white',
                    border: 'none',
                    borderRadius: 8,
                    padding: '0.5rem 1.2rem',
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: 'pointer',
                    boxShadow: '0 1px 4px #cceedd'
                  }}>Book</button>
                  <button onClick={() => navigate(`/tutor/${tutor.id}`)} style={{
                    background: '#eee',
                    color: '#222',
                    border: 'none',
                    borderRadius: 8,
                    padding: '0.5rem 1.2rem',
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: 'pointer',
                    boxShadow: '0 1px 4px #eee'
                  }}>More</button>
                </div>
              </div>
            );
          })}
        </div>
        {filtered.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '2rem',
            color: '#666',
            fontSize: '1.1rem'
          }}>
            No SMC tutors found matching your criteria.
          </div>
        )}
      </div>
    </div>
  );
}
